<div class="adx-user-avatar" [style.width.px]="size" [style.height.px]="size">
    @if (avatarUrl$ | async; as url) {
        <img
                [src]="url"
                [alt]="altText"
                [style.width.px]="size"
                [style.height.px]="size"
                (error)="onImageError()"
                class="adx-avatar-img">
    } @else {
        <div class="adx-avatar-placeholder" [style.width.px]="size" [style.height.px]="size">
            <span class="adx-avatar-initials" [style.font-size.px]="size / 2.5">{{ getInitials() }}</span>
        </div>
    }
</div>
